import { useCallback } from 'react';
import { useQueryClient, useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getEmbedKey } from '../../utils/keys';
export const useEmbed = (options) => {
    const { variables, useQueryOptions } = options || {};
    const queryClient = useQueryClient();
    const { client } = useTribeClient();
    const asyncEmbed = useCallback(async (variables) => {
        const data = await queryClient.fetchQuery(getEmbedKey({ variables }), () => client.media.embed({
            options: JSON.stringify({
                iframe: '1',
                omit_script: '1',
            }),
            ...variables,
        }), useQueryOptions);
        return data;
    }, [queryClient, client, useQueryOptions]);
    return {
        ...useQuery(getEmbedKey({ variables }), () => client.media.embed(variables), { ...useQueryOptions, enabled: !!(variables === null || variables === void 0 ? void 0 : variables.url) }),
        asyncQuery: asyncEmbed,
    };
};
//# sourceMappingURL=useEmbed.js.map